export enum StatusThemeVariant {
	SUCCESS = 'success',
	PENDING = 'pending',
	ERROR = 'error',
	NEUTRAL = 'neutral',
	INACTIVE = 'inactive',
}
